export interface ReviewKeyword {
  id: string;
  label: string;
  image: string;
  category: '음식/가격' | '서비스' | '분위기' | '기타';
}

export const REVIEW_KEYWORDS: ReviewKeyword[] = [
  // 음식/가격
  {
    id: 'food_delicious',
    label: '맛이 좋아요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/leaf20220119222023.png',
    category: '음식/가격',
  },
  {
    id: 'food_quality',
    label: '뛰어난 음식 퀄리티',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/artist_palette20220119222240.png',
    category: '음식/가격',
  },
  {
    id: 'ingredient_good',
    label: '좋은 재료 사용',
    image: 'https://ssl.pstatic.net/static/pup/emoji/coffee20220119222225.png',
    category: '음식/가격',
  },
  {
    id: 'result_satisfied',
    label: '만족스러운 식사',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/face_savoring_food20220119222022.png',
    category: '음식/가격',
  },
  {
    id: 'variety_menu',
    label: '다양한 메뉴',
    image: 'https://ssl.pstatic.net/static/pup/emoji/cook20220119222024.png',
    category: '음식/가격',
  },
  {
    id: 'price_reasonable',
    label: '합리적인 가격',
    image: 'https://ssl.pstatic.net/static/pup/emoji/coin20220119222025.png',
    category: '음식/가격',
  },
  {
    id: 'price_worth',
    label: '가격 대비 만족',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/gem_stone20220119222239.png',
    category: '음식/가격',
  },

  // 서비스
  {
    id: 'service_professional',
    label: '전문적인 서비스',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/gem_stone20220119222239.png',
    category: '서비스',
  },
  {
    id: 'service_kind',
    label: '친절한 서비스',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/beating_heart20220119222223.png',
    category: '서비스',
  },
  {
    id: 'service_fast',
    label: '빠른 서비스',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/stopwatch20220119222225.png',
    category: '서비스',
  },
  {
    id: 'service_careful',
    label: '세심한 서비스',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/sparkles20220119222028.png',
    category: '서비스',
  },
  {
    id: 'recommendation_good',
    label: '좋은 메뉴 추천',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/speaking_head20220119222227.png',
    category: '서비스',
  },
  {
    id: 'service_attentive',
    label: '세심한 배려',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/green_heart20220119222224.png',
    category: '서비스',
  },
  {
    id: 'time_flexible',
    label: '시간 조율 편함',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/stopwatch20220119222225.png',
    category: '서비스',
  },
  {
    id: 'explain_detail',
    label: '자세한 설명',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/light_bulb20220119222315.png',
    category: '서비스',
  },
  // 분위기
  {
    id: 'interior_cool',
    label: '인테리어가 멋져요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/couch_and_lamp20220119222025.png',
    category: '분위기',
  },
  {
    id: 'music_good',
    label: '음악이 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/musical_note20220119222233.png',
    category: '분위기',
  },
  {
    id: 'talk_good',
    label: '대화하기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/speaking_head20220119222227.png',
    category: '분위기',
  },
  {
    id: 'together',
    label: '단체모임 하기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/busts_in_silhouette20220119222027.png',
    category: '분위기',
  },
  {
    id: 'drink_alone',
    label: '혼술하기 좋아요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/whisky20220119222233.png',
    category: '분위기',
  },
  {
    id: 'eat_alone',
    label: '혼밥하기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/rice_ball20220119222026.png',
    category: '분위기',
  },
  {
    id: 'study_good',
    label: '집중하기 좋아요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/laptop20220119222228.png',
    category: '분위기',
  },
  {
    id: 'outdoor_good',
    label: '야외공간이 멋져요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/sun20220119224232.png',
    category: '분위기',
  },
  {
    id: 'atmosphere_calm',
    label: '차분한 분위기에요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/face_relieved20220119222233.png',
    category: '분위기',
  },
  {
    id: 'cozy',
    label: '아늑해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/face_smiling20220119222244.png',
    category: '분위기',
  },
  {
    id: 'view_good',
    label: '뷰가 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/framed_picture20220119222027.png',
    category: '분위기',
  },
  {
    id: 'spacious',
    label: '매장이 넓어요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/eyes20220119222026.png',
    category: '분위기',
  },
  {
    id: 'concept_unique',
    label: '컨셉이 독특해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/light_bulb20220119222315.png',
    category: '분위기',
  },
  {
    id: 'photo_good',
    label: '사진이 잘 나와요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/camera_with_flash20220119222227.png',
    category: '분위기',
  },
  // 기타
  {
    id: 'kind',
    label: '친절해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/beating_heart20220119222223.png',
    category: '기타',
  },
  {
    id: 'store_clean',
    label: '매장이 청결해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/sparkles20220119222028.png',
    category: '기타',
  },
  {
    id: 'toilet_clean',
    label: '화장실이 깨끗해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/restroom20220119222222.png',
    category: '기타',
  },
  {
    id: 'parking_easy',
    label: '주차하기 편해요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/park_sign20220119222222.png',
    category: '기타',
  },
  {
    id: 'stay_long',
    label: '오래 머무르기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/face_relieved20220119222233.png',
    category: '기타',
  },
  {
    id: 'room_nice',
    label: '룸이 잘 되어있어요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/room20220325175453.png',
    category: '기타',
  },
  {
    id: 'food_fast',
    label: '음식이 빨리 나와요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/stopwatch20220119222225.png',
    category: '기타',
  },
  {
    id: 'pet_good',
    label: '반려동물과 가기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/dog_face20220119222302.png',
    category: '기타',
  },
  {
    id: 'kid_good',
    label: '아이와 가기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/baby_face20220119224307.png',
    category: '기타',
  },
  {
    id: 'party_good',
    label: '파티하기 좋아요',
    image:
      'https://ssl.pstatic.net/static/pup/emoji/party_popper20220119222255.png',
    category: '기타',
  },
  {
    id: 'special_day',
    label: '특별한 날 가기 좋아요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/bouquet20220119222223.png',
    category: '기타',
  },
  {
    id: 'comfy',
    label: '좌석이 편해요',
    image: 'https://ssl.pstatic.net/static/pup/emoji/couch20220119222228.png',
    category: '기타',
  },
];
